import React, { useEffect, useState } from 'react';
import api from '../api/client';

export default function SponsorBanner({ eventId, global: isGlobal }) {
  const [sponsors, setSponsors] = useState([]);
  const [idx, setIdx]           = useState(0);
  const [fade, setFade]         = useState(true);

  useEffect(() => {
    const url = isGlobal ? '/api/sponsors' : `/api/events/${eventId}/sponsors`;
    api.get(url).then((r) => setSponsors(r.data)).catch(() => {});
  }, [eventId, isGlobal]);

  useEffect(() => {
    if (sponsors.length <= 1) return;
    const t = setInterval(() => {
      setFade(false);
      setTimeout(() => { setIdx((i) => (i + 1) % sponsors.length); setFade(true); }, 350);
    }, 4000);
    return () => clearInterval(t);
  }, [sponsors.length]);

  if (sponsors.length === 0) return null;

  const s = sponsors[idx];

  return (
    <div className="mt-8 bg-ocean-900 rounded-lg overflow-hidden">
      <div className="px-6 py-3 border-b border-ocean-800">
        <p className="text-xs font-bold text-ocean-400 uppercase tracking-widest text-center">
          Unsere Sponsoren
        </p>
      </div>

      <div
        className="flex flex-col items-center justify-center py-8 px-6"
        style={{ minHeight: 160, opacity: fade ? 1 : 0, transition: 'opacity 0.35s ease' }}
      >
        {s.logo_path ? (
          <>
            {/* weißes Logo-Pad damit bunte Logos auf dunklem Hintergrund lesbar sind */}
            <div style={{
              background: '#fff',
              borderRadius: 8,
              padding: '12px 24px',
              marginBottom: 12,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: 160,
              minHeight: 80,
            }}>
              <img
                src={s.logo_path}
                alt={s.name}
                style={{ maxHeight: 72, maxWidth: 240, objectFit: 'contain', display: 'block' }}
              />
            </div>
            <p className="text-ocean-200 text-sm font-semibold">{s.name}</p>
          </>
        ) : (
          <p className="text-3xl font-extrabold text-white tracking-tight">{s.name}</p>
        )}

        {s.website && (
          <a href={s.website} target="_blank" rel="noreferrer"
            className="text-ocean-400 text-xs mt-1.5 no-underline hover:text-ocean-200 hover:underline transition-colors">
            {s.website.replace(/^https?:\/\//, '')}
          </a>
        )}
      </div>

      {sponsors.length > 1 && (
        <div className="flex justify-center items-center gap-1.5 pb-4">
          {sponsors.map((_, i) => (
            <button key={i}
              onClick={() => { setFade(false); setTimeout(() => { setIdx(i); setFade(true); }, 200); }}
              className={`h-1.5 rounded-full border-0 cursor-pointer transition-all duration-300 ${
                i === idx ? 'w-4 bg-sand-400' : 'w-1.5 bg-ocean-700 hover:bg-ocean-500'
              }`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
